export const Footer = (props) => {
  
  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; 2023 Top Notch Services. Design by{' '}
            <a href='https://www.linkedin.com/in/amernath-vinothakrishnan' rel='nofollow'>
              Amernath Vinothakrishnan
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
